// Cache for loaded languages
const languageCache = new Map();

// Current language (starts as null, will be set after loading)
let currLang = null;

// Load all languages eagerly for backward compatibility
// TODO: Convert to lazy loading by removing these imports and using loadLanguage()
import eng from './translations/english.json';
import hin from './translations/hi.json';
import tam from './translations/ta.json';
import ar from './translations/ar.json';
import pa from './translations/pa.json';
import mr from './translations/mr.json';
import kn from './translations/kn.json';
import gu from './translations/gu.json';
import ur from './translations/ur.json';
import sw from './translations/sw.json';
import tl from './translations/tl.json';
import cs from './translations/cs.json';
import ne from './translations/ne.json';
import te from './translations/te.json';

// Populate cache
languageCache.set('eng', eng);
languageCache.set('hin', hin);
languageCache.set('tam', tam);
languageCache.set('ar', ar);
languageCache.set('pa', pa);
languageCache.set('mr', mr);
languageCache.set('kn', kn);
languageCache.set('gu', gu);
languageCache.set('ur', ur);
languageCache.set('sw', sw);
languageCache.set('tl', tl);
languageCache.set('cs', cs);
languageCache.set('ne', ne);
languageCache.set('te', te);

// Function to add missing properties
function addMissingProperties(source, ...targets) {
  targets.forEach((target) => {
    for (const key in source) {
      if (source.hasOwnProperty(key) && !target.hasOwnProperty(key)) {
        target[key] = source[key];
      }
    }
  });
}

// Add missing properties from English to other languages
let languageList = [hin, tam, ar, pa, mr, kn, gu, ur, sw, tl, cs, ne, te];
addMissingProperties(eng, ...languageList);

// Initialize current language
currLang = eng; // Default to English

// Set language from localStorage
if (typeof localStorage !== 'undefined') {
  const storedLang = localStorage.getItem('language');
  if (storedLang) {
    try {
      const langCode = JSON.parse(storedLang)[0][0];
      if (languageCache.has(langCode)) {
        currLang = languageCache.get(langCode);
      }
    } catch (error) {
      console.warn('Failed to parse stored language, using English', error);
    }
  } else {
    localStorage.setItem('language', '[["eng"]]');
  }
}

export function loadLanguage(langCode) {
  if (languageCache.has(langCode)) {
    currLang = languageCache.get(langCode);
    return currLang;
  }
  // Fallback to English for unknown language codes
  currLang = eng;
  return currLang;
}

// Function to change language (can be used with lazy loading)
export function setLanguage(langCode) {
  const languageData = loadLanguage(langCode);
  localStorage.setItem('language', `[["${langCode}"]]`);
  return languageData;
}

// Function to get current language
export function getCurrentLanguage() {
  return currLang;
}

export { currLang, eng, hin, tam, ar, pa, mr, kn, gu, ur, sw, tl, cs, ne, te };
